<app-topic-form
[method]="method"
[csmTopicId]="topicId"
[token]="token"
[access]="ExplainAppAccess.EXPLAIN_CSM"
(TopicSubmitted)="onReceivedTopic($event)"></app-topic-form>
